exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Lobster);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Fugaz+One);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto|Roboto:700|Roboto:800|Roboto:900|Roboto:900i);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@400;500;700;900&display=swap);", ""]);

// module
exports.push([module.id, "\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./~/postcss-loader!./src/static/styles/fonts.scss
// module id = 352
// module chunks = 0